'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
});

var _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

var propTypes = {
  on: _propTypes2.default.bool.isRequired,
  onClick: _propTypes2.default.func.isRequired,
  enabled: _propTypes2.default.bool,
  className: _propTypes2.default.string
},
    defaultProps = {
  enabled: !0,
  className: '',
  onDisabledClick: function onDisabledClick() {}
};

function Switch(a) {
  var b = a.on,
      c = a.onClick,
      d = a.onDisabledClick,
      f = a.enabled,
      e = a.className,
      g = a.children,
      h = ['switch', e, b ? 'on ' : '', f ? '' : 'disabled '].join(' ');
  return _react2.default.createElement('div', {
    className: h,
    onClick: function onClick(a) {
      return f ? c(a) : d(a);
    }
  }, _react2.default.createElement('div', {
    className: 'switch-toggle',
    children: g
  }));
}

Switch.propTypes = propTypes, Switch.defaultProps = defaultProps, exports.default = Switch;